//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            options: [
                {
                    title: 'Papas fritas',
                    active: true,
                },
                {
                    title: 'Aros de cebolla',
                    active: false,
                },
                {
                    title: 'Salsa Ranch',
                    active: true,
                },
            ],
        }
    },
}
